import { render } from "./Category.vue?vue&type=template&id=762c1828"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=762c1828&lang=css"
script.render = render

export default script